import { createFileRoute } from '@tanstack/react-router'
import { cacheHeaders } from '~/lib/site/cache'
import {
  WhistleblowerPage,
  whistleblowerHead,
} from '~/components/sections/WhistleblowerPage'

export const Route = createFileRoute('/es/whistleblower-support')({
  headers: () => cacheHeaders.content,
  head: () => whistleblowerHead('es'),
  component: () => <WhistleblowerPage lang="es" />,
})
